export const voteApps = [
  {
    id: 'tDVW-318f6c0edd089bab291b51559f6bcedec8a6963afc0a69637bbbd04e22aa3f41-2032915eb993a87d96e3c92eaf3d5a5991aaf3c43167eea1d9e6358f636ff460-1127a0d7f1ffe70b8b0297a8283f434b58bd062be6ef0dde09fda82c2aab40d3',
    chainId: 'tDVW',
    daoId: '318f6c0edd089bab291b51559f6bcedec8a6963afc0a69637bbbd04e22aa3f41',
    proposalId: '2032915eb993a87d96e3c92eaf3d5a5991aaf3c43167eea1d9e6358f636ff460',
    proposalTitle: '09-10 apps',
    proposalDescription:
      '##GameRanking:skeddy,xrocket,favorite-stickers-bot,tapswap,memefi-coin,breath-of-calm,catizen,blum,okx-racer,dotcoin,water-reminder',
    activeStartTime: '2024-09-10T07:50:08.6967865Z',
    activeEndTime: '2024-09-11T07:50:08.6967865Z',
    appId: '1127a0d7f1ffe70b8b0297a8283f434b58bd062be6ef0dde09fda82c2aab40d3',
    alias: 'skeddy',
    title: 'Skeddy',
    icon: 'https://strapi-images-data.s3.eu-central-1.amazonaws.com/2023_09_16_17_25_20_cd1066c266.jpg',
    description:
      'Skeddy is a simple yet powerful reminder tool that can help you create and manage your reminders.',
    editorChoice: false,
    deployTime: '2024-09-10T07:50:08.6967865Z',
    voteAmount: 0,
    votePercent: 0,
    pointsAmount: 0,
    pointsPercent: 0,
    url: 'https://t.me/SkeddyBot/',
    longDescription: null,
    screenshots: [],
  },
  {
    id: 'tDVW-318f6c0edd089bab291b51559f6bcedec8a6963afc0a69637bbbd04e22aa3f41-2032915eb993a87d96e3c92eaf3d5a5991aaf3c43167eea1d9e6358f636ff460-b2da030c47833de59f4ed6456b205c34ac97ad0c19b6956bf9488f60317dc543',
    chainId: 'tDVW',
    daoId: '318f6c0edd089bab291b51559f6bcedec8a6963afc0a69637bbbd04e22aa3f41',
    proposalId: '2032915eb993a87d96e3c92eaf3d5a5991aaf3c43167eea1d9e6358f636ff460',
    proposalTitle: '09-10 apps',
    proposalDescription:
      '##GameRanking:skeddy,xrocket,favorite-stickers-bot,tapswap,memefi-coin,breath-of-calm,catizen,blum,okx-racer,dotcoin,water-reminder',
    activeStartTime: '2024-09-10T07:50:08.6967865Z',
    activeEndTime: '2024-09-11T07:50:08.6967865Z',
    appId: 'b2da030c47833de59f4ed6456b205c34ac97ad0c19b6956bf9488f60317dc543',
    alias: 'xrocket',
    title: 'xRocket',
    icon: 'https://strapi-images-data.s3.eu-central-1.amazonaws.com/2023_10_26_15_30_35_4a7bc164fc.jpg',
    description: 'Trade, send, and receive popular cryptocurrencies.',
    editorChoice: false,
    deployTime: '2024-09-10T07:50:08.6967865Z',
    voteAmount: 0,
    votePercent: 0,
    pointsAmount: 0,
    pointsPercent: 0,
    url: 'https://t.me/xrocket',
    longDescription: null,
    screenshots: [
      'https://strapi-images-data.s3.eu-central-1.amazonaws.com/Slide_2_6efea57346.png',
      'https://strapi-images-data.s3.eu-central-1.amazonaws.com/Slide_1_b4504f7e8e.png',
      'https://strapi-images-data.s3.eu-central-1.amazonaws.com/Slide_3_737a9e1166.png',
      'https://strapi-images-data.s3.eu-central-1.amazonaws.com/Slide_4_978ee1871a.png',
    ],
  },
  {
    id: 'tDVW-318f6c0edd089bab291b51559f6bcedec8a6963afc0a69637bbbd04e22aa3f41-2032915eb993a87d96e3c92eaf3d5a5991aaf3c43167eea1d9e6358f636ff460-084420cf365d5767c67026ea52f4689c75edec254697e887c46cfef26bccef01',
    chainId: 'tDVW',
    daoId: '318f6c0edd089bab291b51559f6bcedec8a6963afc0a69637bbbd04e22aa3f41',
    proposalId: '2032915eb993a87d96e3c92eaf3d5a5991aaf3c43167eea1d9e6358f636ff460',
    proposalTitle: '09-10 apps',
    proposalDescription:
      '##GameRanking:skeddy,xrocket,favorite-stickers-bot,tapswap,memefi-coin,breath-of-calm,catizen,blum,okx-racer,dotcoin,water-reminder',
    activeStartTime: '2024-09-10T07:50:08.6967865Z',
    activeEndTime: '2024-09-11T07:50:08.6967865Z',
    appId: '084420cf365d5767c67026ea52f4689c75edec254697e887c46cfef26bccef01',
    alias: 'favorite-stickers-bot',
    title: 'Favorite Stickers Bot',
    icon: 'https://strapi-images-data.s3.eu-central-1.amazonaws.com/2023_08_08_11_47_10_66d814ddbc.jpg',
    description:
      'I&#x27;m the emoji and sticker wizard! Transform photos, videos, and GIFs into cool stickers in a snap.',
    editorChoice: false,
    deployTime: '2024-09-10T07:50:08.6967865Z',
    voteAmount: 0,
    votePercent: 0,
    pointsAmount: 0,
    pointsPercent: 0,
    url: 'https://t.me/fStikBot/',
    longDescription: null,
    screenshots: [],
  },
  {
    id: 'tDVW-318f6c0edd089bab291b51559f6bcedec8a6963afc0a69637bbbd04e22aa3f41-2032915eb993a87d96e3c92eaf3d5a5991aaf3c43167eea1d9e6358f636ff460-3188e85c8e633a2de635d968b3f27b418c94e745b7c78af2c906da06ee229e8a',
    chainId: 'tDVW',
    daoId: '318f6c0edd089bab291b51559f6bcedec8a6963afc0a69637bbbd04e22aa3f41',
    proposalId: '2032915eb993a87d96e3c92eaf3d5a5991aaf3c43167eea1d9e6358f636ff460',
    proposalTitle: '09-10 apps',
    proposalDescription:
      '##GameRanking:skeddy,xrocket,favorite-stickers-bot,tapswap,memefi-coin,breath-of-calm,catizen,blum,okx-racer,dotcoin,water-reminder',
    activeStartTime: '2024-09-10T07:50:08.6967865Z',
    activeEndTime: '2024-09-11T07:50:08.6967865Z',
    appId: '3188e85c8e633a2de635d968b3f27b418c94e745b7c78af2c906da06ee229e8a',
    alias: 'tapswap',
    title: 'TapSwap',
    icon: 'https://strapi-images-data.s3.eu-central-1.amazonaws.com/2024_05_29_00_22_59_7a7dd228c2.jpg',
    description: 'Tap on the coin and see your balance rise.',
    editorChoice: true,
    deployTime: '2024-09-10T07:50:08.6967865Z',
    voteAmount: 0,
    votePercent: 0,
    pointsAmount: 0,
    pointsPercent: 0,
    url: 'https://t.me/tapswap_bot',
    longDescription:
      "TapSwap is a cutting-edge financial platform where users can earn tokens by leveraging the mining app's various features. The majority of TapSwap Token (TAPS) distribution will occur among the players here. Do you have friends, relatives, or co-workers? Bring them all into the game. More buddies, more coins.",
    screenshots: [
      'https://strapi-images-data.s3.eu-central-1.amazonaws.com/tapswap1_27a58e7fad.PNG',
      'https://strapi-images-data.s3.eu-central-1.amazonaws.com/tapswap2_3ac44b5b75.PNG',
      'https://strapi-images-data.s3.eu-central-1.amazonaws.com/tapswap3_e538bfd38d.PNG',
      'https://strapi-images-data.s3.eu-central-1.amazonaws.com/tapswap4_163811b512.PNG',
    ],
  },
  {
    id: 'tDVW-318f6c0edd089bab291b51559f6bcedec8a6963afc0a69637bbbd04e22aa3f41-2032915eb993a87d96e3c92eaf3d5a5991aaf3c43167eea1d9e6358f636ff460-e0a334c1ef75750460f61bc17afdd7d0e349cc5957b73e92ab923e8cfab2f545',
    chainId: 'tDVW',
    daoId: '318f6c0edd089bab291b51559f6bcedec8a6963afc0a69637bbbd04e22aa3f41',
    proposalId: '2032915eb993a87d96e3c92eaf3d5a5991aaf3c43167eea1d9e6358f636ff460',
    proposalTitle: '09-10 apps',
    proposalDescription:
      '##GameRanking:skeddy,xrocket,favorite-stickers-bot,tapswap,memefi-coin,breath-of-calm,catizen,blum,okx-racer,dotcoin,water-reminder',
    activeStartTime: '2024-09-10T07:50:08.6967865Z',
    activeEndTime: '2024-09-11T07:50:08.6967865Z',
    appId: 'e0a334c1ef75750460f61bc17afdd7d0e349cc5957b73e92ab923e8cfab2f545',
    alias: 'memefi-coin',
    title: 'MemeFi Coin',
    icon: 'https://strapi-images-data.s3.eu-central-1.amazonaws.com/2024_04_01_14_04_54_f733164f18.jpg',
    description:
      'MemeFi is a fun &amp; rewarding idle game. Tap to kill ghost enemies, invite friends and receive tons of rewards.',
    editorChoice: false,
    deployTime: '2024-09-10T07:50:08.6967865Z',
    voteAmount: 0,
    votePercent: 0,
    pointsAmount: 0,
    pointsPercent: 0,
    url: 'https://t.me/memefi_coin_bot',
    longDescription:
      "MemeFi Coin is an idle game, where users receive virtual rewards for tapping activity. The coins collected by users determine their leaderboard rank. A social and immersive game in its nature, it encourages collaboration via invites and in-game clans. It's an offshoot of the MemeFi mainline Web3 that combines PvE and PvP gameplay with Social Tech.",
    screenshots: [
      'https://strapi-images-data.s3.eu-central-1.amazonaws.com/memefi_T_Gapps_screen1_1_44d8bb4668.png',
      'https://strapi-images-data.s3.eu-central-1.amazonaws.com/memefi_T_Gapps_screen2_1_b5a4d46f79.png',
      'https://strapi-images-data.s3.eu-central-1.amazonaws.com/memefi_T_Gapps_screen3_1_73fb58aed9.png',
    ],
  },
  {
    id: 'tDVW-318f6c0edd089bab291b51559f6bcedec8a6963afc0a69637bbbd04e22aa3f41-2032915eb993a87d96e3c92eaf3d5a5991aaf3c43167eea1d9e6358f636ff460-dae0dc6ce26c6228189f45d9769ccc2e1cb155ef01bbcdaedbf45a12b87cdda8',
    chainId: 'tDVW',
    daoId: '318f6c0edd089bab291b51559f6bcedec8a6963afc0a69637bbbd04e22aa3f41',
    proposalId: '2032915eb993a87d96e3c92eaf3d5a5991aaf3c43167eea1d9e6358f636ff460',
    proposalTitle: '09-10 apps',
    proposalDescription:
      '##GameRanking:skeddy,xrocket,favorite-stickers-bot,tapswap,memefi-coin,breath-of-calm,catizen,blum,okx-racer,dotcoin,water-reminder',
    activeStartTime: '2024-09-10T07:50:08.6967865Z',
    activeEndTime: '2024-09-11T07:50:08.6967865Z',
    appId: 'dae0dc6ce26c6228189f45d9769ccc2e1cb155ef01bbcdaedbf45a12b87cdda8',
    alias: 'breath-of-calm',
    title: 'Breath of Calm',
    icon: 'https://strapi-images-data.s3.eu-central-1.amazonaws.com/2023_12_06_14_15_11_ac341f1ed7.jpg',
    description:
      'Rhythmic breathing to relieve stress and anxiety. Increase concentration. Fall asleep in 20 minutes.',
    editorChoice: false,
    deployTime: '2024-09-10T07:50:08.6967865Z',
    voteAmount: 0,
    votePercent: 0,
    pointsAmount: 0,
    pointsPercent: 0,
    url: 'https://t.me/bcalm_bot',
    longDescription: null,
    screenshots: [],
  },
  {
    id: 'tDVW-318f6c0edd089bab291b51559f6bcedec8a6963afc0a69637bbbd04e22aa3f41-2032915eb993a87d96e3c92eaf3d5a5991aaf3c43167eea1d9e6358f636ff460-1fb1b2cb0b2c9d715ec8ee84b7f3e7683a6278dd5d2b9a36d73be9a2638196f4',
    chainId: 'tDVW',
    daoId: '318f6c0edd089bab291b51559f6bcedec8a6963afc0a69637bbbd04e22aa3f41',
    proposalId: '2032915eb993a87d96e3c92eaf3d5a5991aaf3c43167eea1d9e6358f636ff460',
    proposalTitle: '09-10 apps',
    proposalDescription:
      '##GameRanking:skeddy,xrocket,favorite-stickers-bot,tapswap,memefi-coin,breath-of-calm,catizen,blum,okx-racer,dotcoin,water-reminder',
    activeStartTime: '2024-09-10T07:50:08.6967865Z',
    activeEndTime: '2024-09-11T07:50:08.6967865Z',
    appId: '1fb1b2cb0b2c9d715ec8ee84b7f3e7683a6278dd5d2b9a36d73be9a2638196f4',
    alias: 'catizen',
    title: 'Catizen',
    icon: 'https://strapi-images-data.s3.eu-central-1.amazonaws.com/2024_03_08_15_30_10_12c7b97013.jpg',
    description: 'Play, Earn - Where Every Game Leads to an Airdrop.',
    editorChoice: true,
    deployTime: '2024-09-10T07:50:08.6967865Z',
    voteAmount: 0,
    votePercent: 0,
    pointsAmount: 0,
    pointsPercent: 0,
    url: 'https://t.me/catizenbot',
    longDescription: null,
    screenshots: [],
  },
  {
    id: 'tDVW-318f6c0edd089bab291b51559f6bcedec8a6963afc0a69637bbbd04e22aa3f41-2032915eb993a87d96e3c92eaf3d5a5991aaf3c43167eea1d9e6358f636ff460-eb6d5f7e3dfa89aa451d784b354c4f4e04ab022ba220db0a748a235015ed0047',
    chainId: 'tDVW',
    daoId: '318f6c0edd089bab291b51559f6bcedec8a6963afc0a69637bbbd04e22aa3f41',
    proposalId: '2032915eb993a87d96e3c92eaf3d5a5991aaf3c43167eea1d9e6358f636ff460',
    proposalTitle: '09-10 apps',
    proposalDescription:
      '##GameRanking:skeddy,xrocket,favorite-stickers-bot,tapswap,memefi-coin,breath-of-calm,catizen,blum,okx-racer,dotcoin,water-reminder',
    activeStartTime: '2024-09-10T07:50:08.6967865Z',
    activeEndTime: '2024-09-11T07:50:08.6967865Z',
    appId: 'eb6d5f7e3dfa89aa451d784b354c4f4e04ab022ba220db0a748a235015ed0047',
    alias: 'blum',
    title: 'Blum',
    icon: 'https://strapi-images-data.s3.eu-central-1.amazonaws.com/photo_2024_05_27_19_34_35_84eeee2b39.jpeg',
    description:
      'Blum brings you every coin you need. Just one place, no more switching between multiple platforms.',
    editorChoice: true,
    deployTime: '2024-09-10T07:50:08.6967865Z',
    voteAmount: 0,
    votePercent: 0,
    pointsAmount: 0,
    pointsPercent: 0,
    url: 'https://t.me/BlumCryptoBot',
    longDescription:
      "Your go-to app for crypto trading - all the cool coins and tokens, right in your pocket! Start farming points now, and who knows what cool stuff you'll snag with them soon! Got friends? Bring'em in! The more, the merrier! \n\nRemember: Blum is where growth thrives and endless opportunities bloom!",
    screenshots: [
      'https://strapi-images-data.s3.eu-central-1.amazonaws.com/IMG_6_C88_FD_3_E5055_1_3cad49f054.jpeg',
      'https://strapi-images-data.s3.eu-central-1.amazonaws.com/IMG_CB_1217_F717_BC_1_23de4fcb38.jpeg',
      'https://strapi-images-data.s3.eu-central-1.amazonaws.com/IMG_611339_AB_55_F1_1_4ac00f98bf.jpeg',
    ],
  },
  {
    id: 'tDVW-318f6c0edd089bab291b51559f6bcedec8a6963afc0a69637bbbd04e22aa3f41-2032915eb993a87d96e3c92eaf3d5a5991aaf3c43167eea1d9e6358f636ff460-abaaf5f673d86b9d824030a466f0df3e83584c7dadce9d616400023fa9778043',
    chainId: 'tDVW',
    daoId: '318f6c0edd089bab291b51559f6bcedec8a6963afc0a69637bbbd04e22aa3f41',
    proposalId: '2032915eb993a87d96e3c92eaf3d5a5991aaf3c43167eea1d9e6358f636ff460',
    proposalTitle: '09-10 apps',
    proposalDescription:
      '##GameRanking:skeddy,xrocket,favorite-stickers-bot,tapswap,memefi-coin,breath-of-calm,catizen,blum,okx-racer,dotcoin,water-reminder',
    activeStartTime: '2024-09-10T07:50:08.6967865Z',
    activeEndTime: '2024-09-11T07:50:08.6967865Z',
    appId: 'abaaf5f673d86b9d824030a466f0df3e83584c7dadce9d616400023fa9778043',
    alias: 'okx-racer',
    title: 'OKX Racer',
    icon: 'https://strapi-images-data.s3.eu-central-1.amazonaws.com/2024_07_22_23_39_35_015277c3d8.jpg',
    description: 'Rev your engines and guess token prices in real-time! ',
    editorChoice: false,
    deployTime: '2024-09-10T07:50:08.6967865Z',
    voteAmount: 0,
    votePercent: 0,
    pointsAmount: 0,
    pointsPercent: 0,
    url: 'https://t.me/OKX_official_bot',
    longDescription:
      'Welcome to the OKX Racer! Rev your engines and predict token prices in real-time! Moon or doom in the next 5 seconds? Correct guesses earn points and surprises! Boost your score by inviting friends! Do you have what it takes to be at the top?',
    screenshots: [
      'https://strapi-images-data.s3.eu-central-1.amazonaws.com/okx1_554d82ea06.PNG',
      'https://strapi-images-data.s3.eu-central-1.amazonaws.com/okx2_c19e4657ab.PNG',
      'https://strapi-images-data.s3.eu-central-1.amazonaws.com/okx3_fb4061e709.PNG',
    ],
  },
  {
    id: 'tDVW-318f6c0edd089bab291b51559f6bcedec8a6963afc0a69637bbbd04e22aa3f41-2032915eb993a87d96e3c92eaf3d5a5991aaf3c43167eea1d9e6358f636ff460-f9568468951b9369ec2c852260639564e821e7339265bf00b012f1fd4bbc59d1',
    chainId: 'tDVW',
    daoId: '318f6c0edd089bab291b51559f6bcedec8a6963afc0a69637bbbd04e22aa3f41',
    proposalId: '2032915eb993a87d96e3c92eaf3d5a5991aaf3c43167eea1d9e6358f636ff460',
    proposalTitle: '09-10 apps',
    proposalDescription:
      '##GameRanking:skeddy,xrocket,favorite-stickers-bot,tapswap,memefi-coin,breath-of-calm,catizen,blum,okx-racer,dotcoin,water-reminder',
    activeStartTime: '2024-09-10T07:50:08.6967865Z',
    activeEndTime: '2024-09-11T07:50:08.6967865Z',
    appId: 'f9568468951b9369ec2c852260639564e821e7339265bf00b012f1fd4bbc59d1',
    alias: 'dotcoin',
    title: 'Dotcoin',
    icon: 'https://strapi-images-data.s3.eu-central-1.amazonaws.com/2024_04_24_12_15_05_a5e92b5136.jpg',
    description: 'Everything starts from a DOT.',
    editorChoice: false,
    deployTime: '2024-09-10T07:50:08.6967865Z',
    voteAmount: 0,
    votePercent: 0,
    pointsAmount: 0,
    pointsPercent: 0,
    url: 'https://t.me/dotcoin_bot',
    longDescription:
      'Dotcoin is Telegram game where you get Dotcoins by clicking on a DOT. Players can join clans (Telegram channels and chats), complete tasks, invite friends and increase levels.',
    screenshots: [
      'https://strapi-images-data.s3.eu-central-1.amazonaws.com/dotcoin1_72c9d3635d.PNG',
      'https://strapi-images-data.s3.eu-central-1.amazonaws.com/dotcoin2_a71926b62b.PNG',
    ],
  },
  {
    id: 'tDVW-318f6c0edd089bab291b51559f6bcedec8a6963afc0a69637bbbd04e22aa3f41-2032915eb993a87d96e3c92eaf3d5a5991aaf3c43167eea1d9e6358f636ff460-fa8877e8201e3e8c1bc35f01a393891f4dde00b6a6a495dbc047edaeabe5d6e8',
    chainId: 'tDVW',
    daoId: '318f6c0edd089bab291b51559f6bcedec8a6963afc0a69637bbbd04e22aa3f41',
    proposalId: '2032915eb993a87d96e3c92eaf3d5a5991aaf3c43167eea1d9e6358f636ff460',
    proposalTitle: '09-10 apps',
    proposalDescription:
      '##GameRanking:skeddy,xrocket,favorite-stickers-bot,tapswap,memefi-coin,breath-of-calm,catizen,blum,okx-racer,dotcoin,water-reminder',
    activeStartTime: '2024-09-10T07:50:08.6967865Z',
    activeEndTime: '2024-09-11T07:50:08.6967865Z',
    appId: 'fa8877e8201e3e8c1bc35f01a393891f4dde00b6a6a495dbc047edaeabe5d6e8',
    alias: 'water-reminder',
    title: 'Water Reminder',
    icon: 'https://strapi-images-data.s3.eu-central-1.amazonaws.com/2024_01_10_17_00_26_867a362693.jpg',
    description: 'This bot will help you drink enough water for a healthy lifestyle.',
    editorChoice: false,
    deployTime: '2024-09-10T07:50:08.6967865Z',
    voteAmount: 0,
    votePercent: 0,
    pointsAmount: 0,
    pointsPercent: 0,
    url: null,
    longDescription: null,
    screenshots: [],
  },
];
export const voteApps1 = [
  {
    id: 'tDVW-318f6c0edd089bab291b51559f6bcedec8a6963afc0a69637bbbd04e22aa3f41-2032915eb993a87d96e3c92eaf3d5a5991aaf3c43167eea1d9e6358f636ff460-e0a334c1ef75750460f61bc17afdd7d0e349cc5957b73e92ab923e8cfab2f545',
    chainId: 'tDVW',
    daoId: '318f6c0edd089bab291b51559f6bcedec8a6963afc0a69637bbbd04e22aa3f41',
    proposalId: '2032915eb993a87d96e3c92eaf3d5a5991aaf3c43167eea1d9e6358f636ff460',
    proposalTitle: '09-10 apps',
    proposalDescription:
      '##GameRanking:skeddy,xrocket,favorite-stickers-bot,tapswap,memefi-coin,breath-of-calm,catizen,blum,okx-racer,dotcoin,water-reminder',
    activeStartTime: '2024-09-10T07:50:08.6967865Z',
    activeEndTime: '2024-09-11T07:50:08.6967865Z',
    appId: 'e0a334c1ef75750460f61bc17afdd7d0e349cc5957b73e92ab923e8cfab2f545',
    alias: 'memefi-coin',
    title: 'MemeFi Coin',
    icon: 'https://strapi-images-data.s3.eu-central-1.amazonaws.com/2024_04_01_14_04_54_f733164f18.jpg',
    description:
      'MemeFi is a fun &amp; rewarding idle game. Tap to kill ghost enemies, invite friends and receive tons of rewards.',
    editorChoice: false,
    deployTime: '2024-09-10T07:50:08.6967865Z',
    voteAmount: 0,
    votePercent: 0,
    pointsAmount: 0,
    pointsPercent: 0,
    url: 'https://t.me/memefi_coin_bot',
    longDescription:
      "MemeFi Coin is an idle game, where users receive virtual rewards for tapping activity. The coins collected by users determine their leaderboard rank. A social and immersive game in its nature, it encourages collaboration via invites and in-game clans. It's an offshoot of the MemeFi mainline Web3 that combines PvE and PvP gameplay with Social Tech.",
    screenshots: [
      'https://strapi-images-data.s3.eu-central-1.amazonaws.com/memefi_T_Gapps_screen1_1_44d8bb4668.png',
      'https://strapi-images-data.s3.eu-central-1.amazonaws.com/memefi_T_Gapps_screen2_1_b5a4d46f79.png',
      'https://strapi-images-data.s3.eu-central-1.amazonaws.com/memefi_T_Gapps_screen3_1_73fb58aed9.png',
    ],
  },
  {
    id: 'tDVW-318f6c0edd089bab291b51559f6bcedec8a6963afc0a69637bbbd04e22aa3f41-2032915eb993a87d96e3c92eaf3d5a5991aaf3c43167eea1d9e6358f636ff460-b2da030c47833de59f4ed6456b205c34ac97ad0c19b6956bf9488f60317dc543',
    chainId: 'tDVW',
    daoId: '318f6c0edd089bab291b51559f6bcedec8a6963afc0a69637bbbd04e22aa3f41',
    proposalId: '2032915eb993a87d96e3c92eaf3d5a5991aaf3c43167eea1d9e6358f636ff460',
    proposalTitle: '09-10 apps',
    proposalDescription:
      '##GameRanking:skeddy,xrocket,favorite-stickers-bot,tapswap,memefi-coin,breath-of-calm,catizen,blum,okx-racer,dotcoin,water-reminder',
    activeStartTime: '2024-09-10T07:50:08.6967865Z',
    activeEndTime: '2024-09-11T07:50:08.6967865Z',
    appId: 'b2da030c47833de59f4ed6456b205c34ac97ad0c19b6956bf9488f60317dc543',
    alias: 'xrocket',
    title: 'xRocket',
    icon: 'https://strapi-images-data.s3.eu-central-1.amazonaws.com/2023_10_26_15_30_35_4a7bc164fc.jpg',
    description: 'Trade, send, and receive popular cryptocurrencies.',
    editorChoice: false,
    deployTime: '2024-09-10T07:50:08.6967865Z',
    voteAmount: 0,
    votePercent: 0,
    pointsAmount: 0,
    pointsPercent: 0,
    url: 'https://t.me/xrocket',
    longDescription: null,
    screenshots: [
      'https://strapi-images-data.s3.eu-central-1.amazonaws.com/Slide_2_6efea57346.png',
      'https://strapi-images-data.s3.eu-central-1.amazonaws.com/Slide_1_b4504f7e8e.png',
      'https://strapi-images-data.s3.eu-central-1.amazonaws.com/Slide_3_737a9e1166.png',
      'https://strapi-images-data.s3.eu-central-1.amazonaws.com/Slide_4_978ee1871a.png',
    ],
  },
  {
    id: 'tDVW-318f6c0edd089bab291b51559f6bcedec8a6963afc0a69637bbbd04e22aa3f41-2032915eb993a87d96e3c92eaf3d5a5991aaf3c43167eea1d9e6358f636ff460-084420cf365d5767c67026ea52f4689c75edec254697e887c46cfef26bccef01',
    chainId: 'tDVW',
    daoId: '318f6c0edd089bab291b51559f6bcedec8a6963afc0a69637bbbd04e22aa3f41',
    proposalId: '2032915eb993a87d96e3c92eaf3d5a5991aaf3c43167eea1d9e6358f636ff460',
    proposalTitle: '09-10 apps',
    proposalDescription:
      '##GameRanking:skeddy,xrocket,favorite-stickers-bot,tapswap,memefi-coin,breath-of-calm,catizen,blum,okx-racer,dotcoin,water-reminder',
    activeStartTime: '2024-09-10T07:50:08.6967865Z',
    activeEndTime: '2024-09-11T07:50:08.6967865Z',
    appId: '084420cf365d5767c67026ea52f4689c75edec254697e887c46cfef26bccef01',
    alias: 'favorite-stickers-bot',
    title: 'Favorite Stickers Bot',
    icon: 'https://strapi-images-data.s3.eu-central-1.amazonaws.com/2023_08_08_11_47_10_66d814ddbc.jpg',
    description:
      'I&#x27;m the emoji and sticker wizard! Transform photos, videos, and GIFs into cool stickers in a snap.',
    editorChoice: false,
    deployTime: '2024-09-10T07:50:08.6967865Z',
    voteAmount: 0,
    votePercent: 0,
    pointsAmount: 0,
    pointsPercent: 0,
    url: 'https://t.me/fStikBot/',
    longDescription: null,
    screenshots: [],
  },
  {
    id: 'tDVW-318f6c0edd089bab291b51559f6bcedec8a6963afc0a69637bbbd04e22aa3f41-2032915eb993a87d96e3c92eaf3d5a5991aaf3c43167eea1d9e6358f636ff460-f9568468951b9369ec2c852260639564e821e7339265bf00b012f1fd4bbc59d1',
    chainId: 'tDVW',
    daoId: '318f6c0edd089bab291b51559f6bcedec8a6963afc0a69637bbbd04e22aa3f41',
    proposalId: '2032915eb993a87d96e3c92eaf3d5a5991aaf3c43167eea1d9e6358f636ff460',
    proposalTitle: '09-10 apps',
    proposalDescription:
      '##GameRanking:skeddy,xrocket,favorite-stickers-bot,tapswap,memefi-coin,breath-of-calm,catizen,blum,okx-racer,dotcoin,water-reminder',
    activeStartTime: '2024-09-10T07:50:08.6967865Z',
    activeEndTime: '2024-09-11T07:50:08.6967865Z',
    appId: 'f9568468951b9369ec2c852260639564e821e7339265bf00b012f1fd4bbc59d1',
    alias: 'dotcoin',
    title: 'Dotcoin',
    icon: 'https://strapi-images-data.s3.eu-central-1.amazonaws.com/2024_04_24_12_15_05_a5e92b5136.jpg',
    description: 'Everything starts from a DOT.',
    editorChoice: false,
    deployTime: '2024-09-10T07:50:08.6967865Z',
    voteAmount: 0,
    votePercent: 0,
    pointsAmount: 0,
    pointsPercent: 0,
    url: 'https://t.me/dotcoin_bot',
    longDescription:
      'Dotcoin is Telegram game where you get Dotcoins by clicking on a DOT. Players can join clans (Telegram channels and chats), complete tasks, invite friends and increase levels.',
    screenshots: [
      'https://strapi-images-data.s3.eu-central-1.amazonaws.com/dotcoin1_72c9d3635d.PNG',
      'https://strapi-images-data.s3.eu-central-1.amazonaws.com/dotcoin2_a71926b62b.PNG',
    ],
  },
  {
    id: 'tDVW-318f6c0edd089bab291b51559f6bcedec8a6963afc0a69637bbbd04e22aa3f41-2032915eb993a87d96e3c92eaf3d5a5991aaf3c43167eea1d9e6358f636ff460-1fb1b2cb0b2c9d715ec8ee84b7f3e7683a6278dd5d2b9a36d73be9a2638196f4',
    chainId: 'tDVW',
    daoId: '318f6c0edd089bab291b51559f6bcedec8a6963afc0a69637bbbd04e22aa3f41',
    proposalId: '2032915eb993a87d96e3c92eaf3d5a5991aaf3c43167eea1d9e6358f636ff460',
    proposalTitle: '09-10 apps',
    proposalDescription:
      '##GameRanking:skeddy,xrocket,favorite-stickers-bot,tapswap,memefi-coin,breath-of-calm,catizen,blum,okx-racer,dotcoin,water-reminder',
    activeStartTime: '2024-09-10T07:50:08.6967865Z',
    activeEndTime: '2024-09-11T07:50:08.6967865Z',
    appId: '1fb1b2cb0b2c9d715ec8ee84b7f3e7683a6278dd5d2b9a36d73be9a2638196f4',
    alias: 'catizen',
    title: 'Catizen',
    icon: 'https://strapi-images-data.s3.eu-central-1.amazonaws.com/2024_03_08_15_30_10_12c7b97013.jpg',
    description: 'Play, Earn - Where Every Game Leads to an Airdrop.',
    editorChoice: true,
    deployTime: '2024-09-10T07:50:08.6967865Z',
    voteAmount: 0,
    votePercent: 0,
    pointsAmount: 0,
    pointsPercent: 0,
    url: 'https://t.me/catizenbot',
    longDescription: null,
    screenshots: [],
  },
  {
    id: 'tDVW-318f6c0edd089bab291b51559f6bcedec8a6963afc0a69637bbbd04e22aa3f41-2032915eb993a87d96e3c92eaf3d5a5991aaf3c43167eea1d9e6358f636ff460-eb6d5f7e3dfa89aa451d784b354c4f4e04ab022ba220db0a748a235015ed0047',
    chainId: 'tDVW',
    daoId: '318f6c0edd089bab291b51559f6bcedec8a6963afc0a69637bbbd04e22aa3f41',
    proposalId: '2032915eb993a87d96e3c92eaf3d5a5991aaf3c43167eea1d9e6358f636ff460',
    proposalTitle: '09-10 apps',
    proposalDescription:
      '##GameRanking:skeddy,xrocket,favorite-stickers-bot,tapswap,memefi-coin,breath-of-calm,catizen,blum,okx-racer,dotcoin,water-reminder',
    activeStartTime: '2024-09-10T07:50:08.6967865Z',
    activeEndTime: '2024-09-11T07:50:08.6967865Z',
    appId: 'eb6d5f7e3dfa89aa451d784b354c4f4e04ab022ba220db0a748a235015ed0047',
    alias: 'blum',
    title: 'Blum',
    icon: 'https://strapi-images-data.s3.eu-central-1.amazonaws.com/photo_2024_05_27_19_34_35_84eeee2b39.jpeg',
    description:
      'Blum brings you every coin you need. Just one place, no more switching between multiple platforms.',
    editorChoice: true,
    deployTime: '2024-09-10T07:50:08.6967865Z',
    voteAmount: 0,
    votePercent: 0,
    pointsAmount: 0,
    pointsPercent: 0,
    url: 'https://t.me/BlumCryptoBot',
    longDescription:
      "Your go-to app for crypto trading - all the cool coins and tokens, right in your pocket! Start farming points now, and who knows what cool stuff you'll snag with them soon! Got friends? Bring'em in! The more, the merrier! \n\nRemember: Blum is where growth thrives and endless opportunities bloom!",
    screenshots: [
      'https://strapi-images-data.s3.eu-central-1.amazonaws.com/IMG_6_C88_FD_3_E5055_1_3cad49f054.jpeg',
      'https://strapi-images-data.s3.eu-central-1.amazonaws.com/IMG_CB_1217_F717_BC_1_23de4fcb38.jpeg',
      'https://strapi-images-data.s3.eu-central-1.amazonaws.com/IMG_611339_AB_55_F1_1_4ac00f98bf.jpeg',
    ],
  },
  {
    id: 'tDVW-318f6c0edd089bab291b51559f6bcedec8a6963afc0a69637bbbd04e22aa3f41-2032915eb993a87d96e3c92eaf3d5a5991aaf3c43167eea1d9e6358f636ff460-dae0dc6ce26c6228189f45d9769ccc2e1cb155ef01bbcdaedbf45a12b87cdda8',
    chainId: 'tDVW',
    daoId: '318f6c0edd089bab291b51559f6bcedec8a6963afc0a69637bbbd04e22aa3f41',
    proposalId: '2032915eb993a87d96e3c92eaf3d5a5991aaf3c43167eea1d9e6358f636ff460',
    proposalTitle: '09-10 apps',
    proposalDescription:
      '##GameRanking:skeddy,xrocket,favorite-stickers-bot,tapswap,memefi-coin,breath-of-calm,catizen,blum,okx-racer,dotcoin,water-reminder',
    activeStartTime: '2024-09-10T07:50:08.6967865Z',
    activeEndTime: '2024-09-11T07:50:08.6967865Z',
    appId: 'dae0dc6ce26c6228189f45d9769ccc2e1cb155ef01bbcdaedbf45a12b87cdda8',
    alias: 'breath-of-calm',
    title: 'Breath of Calm',
    icon: 'https://strapi-images-data.s3.eu-central-1.amazonaws.com/2023_12_06_14_15_11_ac341f1ed7.jpg',
    description:
      'Rhythmic breathing to relieve stress and anxiety. Increase concentration. Fall asleep in 20 minutes.',
    editorChoice: false,
    deployTime: '2024-09-10T07:50:08.6967865Z',
    voteAmount: 0,
    votePercent: 0,
    pointsAmount: 0,
    pointsPercent: 0,
    url: 'https://t.me/bcalm_bot',
    longDescription: null,
    screenshots: [],
  },
  {
    id: 'tDVW-318f6c0edd089bab291b51559f6bcedec8a6963afc0a69637bbbd04e22aa3f41-2032915eb993a87d96e3c92eaf3d5a5991aaf3c43167eea1d9e6358f636ff460-fa8877e8201e3e8c1bc35f01a393891f4dde00b6a6a495dbc047edaeabe5d6e8',
    chainId: 'tDVW',
    daoId: '318f6c0edd089bab291b51559f6bcedec8a6963afc0a69637bbbd04e22aa3f41',
    proposalId: '2032915eb993a87d96e3c92eaf3d5a5991aaf3c43167eea1d9e6358f636ff460',
    proposalTitle: '09-10 apps',
    proposalDescription:
      '##GameRanking:skeddy,xrocket,favorite-stickers-bot,tapswap,memefi-coin,breath-of-calm,catizen,blum,okx-racer,dotcoin,water-reminder',
    activeStartTime: '2024-09-10T07:50:08.6967865Z',
    activeEndTime: '2024-09-11T07:50:08.6967865Z',
    appId: 'fa8877e8201e3e8c1bc35f01a393891f4dde00b6a6a495dbc047edaeabe5d6e8',
    alias: 'water-reminder',
    title: 'Water Reminder',
    icon: 'https://strapi-images-data.s3.eu-central-1.amazonaws.com/2024_01_10_17_00_26_867a362693.jpg',
    description: 'This bot will help you drink enough water for a healthy lifestyle.',
    editorChoice: false,
    deployTime: '2024-09-10T07:50:08.6967865Z',
    voteAmount: 0,
    votePercent: 0,
    pointsAmount: 0,
    pointsPercent: 0,
    url: null,
    longDescription: null,
    screenshots: [],
  },
  {
    id: 'tDVW-318f6c0edd089bab291b51559f6bcedec8a6963afc0a69637bbbd04e22aa3f41-2032915eb993a87d96e3c92eaf3d5a5991aaf3c43167eea1d9e6358f636ff460-abaaf5f673d86b9d824030a466f0df3e83584c7dadce9d616400023fa9778043',
    chainId: 'tDVW',
    daoId: '318f6c0edd089bab291b51559f6bcedec8a6963afc0a69637bbbd04e22aa3f41',
    proposalId: '2032915eb993a87d96e3c92eaf3d5a5991aaf3c43167eea1d9e6358f636ff460',
    proposalTitle: '09-10 apps',
    proposalDescription:
      '##GameRanking:skeddy,xrocket,favorite-stickers-bot,tapswap,memefi-coin,breath-of-calm,catizen,blum,okx-racer,dotcoin,water-reminder',
    activeStartTime: '2024-09-10T07:50:08.6967865Z',
    activeEndTime: '2024-09-11T07:50:08.6967865Z',
    appId: 'abaaf5f673d86b9d824030a466f0df3e83584c7dadce9d616400023fa9778043',
    alias: 'okx-racer',
    title: 'OKX Racer',
    icon: 'https://strapi-images-data.s3.eu-central-1.amazonaws.com/2024_07_22_23_39_35_015277c3d8.jpg',
    description: 'Rev your engines and guess token prices in real-time! ',
    editorChoice: false,
    deployTime: '2024-09-10T07:50:08.6967865Z',
    voteAmount: 0,
    votePercent: 0,
    pointsAmount: 0,
    pointsPercent: 0,
    url: 'https://t.me/OKX_official_bot',
    longDescription:
      'Welcome to the OKX Racer! Rev your engines and predict token prices in real-time! Moon or doom in the next 5 seconds? Correct guesses earn points and surprises! Boost your score by inviting friends! Do you have what it takes to be at the top?',
    screenshots: [
      'https://strapi-images-data.s3.eu-central-1.amazonaws.com/okx1_554d82ea06.PNG',
      'https://strapi-images-data.s3.eu-central-1.amazonaws.com/okx2_c19e4657ab.PNG',
      'https://strapi-images-data.s3.eu-central-1.amazonaws.com/okx3_fb4061e709.PNG',
    ],
  },
  {
    id: 'tDVW-318f6c0edd089bab291b51559f6bcedec8a6963afc0a69637bbbd04e22aa3f41-2032915eb993a87d96e3c92eaf3d5a5991aaf3c43167eea1d9e6358f636ff460-3188e85c8e633a2de635d968b3f27b418c94e745b7c78af2c906da06ee229e8a',
    chainId: 'tDVW',
    daoId: '318f6c0edd089bab291b51559f6bcedec8a6963afc0a69637bbbd04e22aa3f41',
    proposalId: '2032915eb993a87d96e3c92eaf3d5a5991aaf3c43167eea1d9e6358f636ff460',
    proposalTitle: '09-10 apps',
    proposalDescription:
      '##GameRanking:skeddy,xrocket,favorite-stickers-bot,tapswap,memefi-coin,breath-of-calm,catizen,blum,okx-racer,dotcoin,water-reminder',
    activeStartTime: '2024-09-10T07:50:08.6967865Z',
    activeEndTime: '2024-09-11T07:50:08.6967865Z',
    appId: '3188e85c8e633a2de635d968b3f27b418c94e745b7c78af2c906da06ee229e8a',
    alias: 'tapswap',
    title: 'TapSwap',
    icon: 'https://strapi-images-data.s3.eu-central-1.amazonaws.com/2024_05_29_00_22_59_7a7dd228c2.jpg',
    description: 'Tap on the coin and see your balance rise.',
    editorChoice: true,
    deployTime: '2024-09-10T07:50:08.6967865Z',
    voteAmount: 0,
    votePercent: 0,
    pointsAmount: 0,
    pointsPercent: 0,
    url: 'https://t.me/tapswap_bot',
    longDescription:
      "TapSwap is a cutting-edge financial platform where users can earn tokens by leveraging the mining app's various features. The majority of TapSwap Token (TAPS) distribution will occur among the players here. Do you have friends, relatives, or co-workers? Bring them all into the game. More buddies, more coins.",
    screenshots: [
      'https://strapi-images-data.s3.eu-central-1.amazonaws.com/tapswap1_27a58e7fad.PNG',
      'https://strapi-images-data.s3.eu-central-1.amazonaws.com/tapswap2_3ac44b5b75.PNG',
      'https://strapi-images-data.s3.eu-central-1.amazonaws.com/tapswap3_e538bfd38d.PNG',
      'https://strapi-images-data.s3.eu-central-1.amazonaws.com/tapswap4_163811b512.PNG',
    ],
  },
  {
    id: 'tDVW-318f6c0edd089bab291b51559f6bcedec8a6963afc0a69637bbbd04e22aa3f41-2032915eb993a87d96e3c92eaf3d5a5991aaf3c43167eea1d9e6358f636ff460-1127a0d7f1ffe70b8b0297a8283f434b58bd062be6ef0dde09fda82c2aab40d3',
    chainId: 'tDVW',
    daoId: '318f6c0edd089bab291b51559f6bcedec8a6963afc0a69637bbbd04e22aa3f41',
    proposalId: '2032915eb993a87d96e3c92eaf3d5a5991aaf3c43167eea1d9e6358f636ff460',
    proposalTitle: '09-10 apps',
    proposalDescription:
      '##GameRanking:skeddy,xrocket,favorite-stickers-bot,tapswap,memefi-coin,breath-of-calm,catizen,blum,okx-racer,dotcoin,water-reminder',
    activeStartTime: '2024-09-10T07:50:08.6967865Z',
    activeEndTime: '2024-09-11T07:50:08.6967865Z',
    appId: '1127a0d7f1ffe70b8b0297a8283f434b58bd062be6ef0dde09fda82c2aab40d3',
    alias: 'skeddy',
    title: 'Skeddy',
    icon: 'https://strapi-images-data.s3.eu-central-1.amazonaws.com/2023_09_16_17_25_20_cd1066c266.jpg',
    description:
      'Skeddy is a simple yet powerful reminder tool that can help you create and manage your reminders.',
    editorChoice: false,
    deployTime: '2024-09-10T07:50:08.6967865Z',
    voteAmount: 0,
    votePercent: 0,
    pointsAmount: 0,
    pointsPercent: 0,
    url: 'https://t.me/SkeddyBot/',
    longDescription: null,
    screenshots: [],
  },
];

export const voteApps2 = [
  {
    id: 'tDVW-318f6c0edd089bab291b51559f6bcedec8a6963afc0a69637bbbd04e22aa3f41-2032915eb993a87d96e3c92eaf3d5a5991aaf3c43167eea1d9e6358f636ff460-1127a0d7f1ffe70b8b0297a8283f434b58bd062be6ef0dde09fda82c2aab40d3',
    chainId: 'tDVW',
    daoId: '318f6c0edd089bab291b51559f6bcedec8a6963afc0a69637bbbd04e22aa3f41',
    proposalId: '2032915eb993a87d96e3c92eaf3d5a5991aaf3c43167eea1d9e6358f636ff460',
    proposalTitle: '09-10 apps',
    proposalDescription:
      '##GameRanking:skeddy,xrocket,favorite-stickers-bot,tapswap,memefi-coin,breath-of-calm,catizen,blum,okx-racer,dotcoin,water-reminder',
    activeStartTime: '2024-09-10T07:50:08.6967865Z',
    activeEndTime: '2024-09-11T07:50:08.6967865Z',
    appId: '1127a0d7f1ffe70b8b0297a8283f434b58bd062be6ef0dde09fda82c2aab40d3',
    alias: 'skeddy',
    title: 'Skeddy',
    icon: 'https://strapi-images-data.s3.eu-central-1.amazonaws.com/2023_09_16_17_25_20_cd1066c266.jpg',
    description:
      'Skeddy is a simple yet powerful reminder tool that can help you create and manage your reminders.',
    editorChoice: false,
    deployTime: '2024-09-10T07:50:08.6967865Z',
    voteAmount: 0,
    votePercent: 0,
    pointsAmount: 0,
    pointsPercent: 0,
    url: 'https://t.me/SkeddyBot/',
    longDescription: null,
    screenshots: [],
  },
  {
    id: 'tDVW-318f6c0edd089bab291b51559f6bcedec8a6963afc0a69637bbbd04e22aa3f41-2032915eb993a87d96e3c92eaf3d5a5991aaf3c43167eea1d9e6358f636ff460-e0a334c1ef75750460f61bc17afdd7d0e349cc5957b73e92ab923e8cfab2f545',
    chainId: 'tDVW',
    daoId: '318f6c0edd089bab291b51559f6bcedec8a6963afc0a69637bbbd04e22aa3f41',
    proposalId: '2032915eb993a87d96e3c92eaf3d5a5991aaf3c43167eea1d9e6358f636ff460',
    proposalTitle: '09-10 apps',
    proposalDescription:
      '##GameRanking:skeddy,xrocket,favorite-stickers-bot,tapswap,memefi-coin,breath-of-calm,catizen,blum,okx-racer,dotcoin,water-reminder',
    activeStartTime: '2024-09-10T07:50:08.6967865Z',
    activeEndTime: '2024-09-11T07:50:08.6967865Z',
    appId: 'e0a334c1ef75750460f61bc17afdd7d0e349cc5957b73e92ab923e8cfab2f545',
    alias: 'memefi-coin',
    title: 'MemeFi Coin',
    icon: 'https://strapi-images-data.s3.eu-central-1.amazonaws.com/2024_04_01_14_04_54_f733164f18.jpg',
    description:
      'MemeFi is a fun &amp; rewarding idle game. Tap to kill ghost enemies, invite friends and receive tons of rewards.',
    editorChoice: false,
    deployTime: '2024-09-10T07:50:08.6967865Z',
    voteAmount: 0,
    votePercent: 0,
    pointsAmount: 0,
    pointsPercent: 0,
    url: 'https://t.me/memefi_coin_bot',
    longDescription:
      "MemeFi Coin is an idle game, where users receive virtual rewards for tapping activity. The coins collected by users determine their leaderboard rank. A social and immersive game in its nature, it encourages collaboration via invites and in-game clans. It's an offshoot of the MemeFi mainline Web3 that combines PvE and PvP gameplay with Social Tech.",
    screenshots: [
      'https://strapi-images-data.s3.eu-central-1.amazonaws.com/memefi_T_Gapps_screen1_1_44d8bb4668.png',
      'https://strapi-images-data.s3.eu-central-1.amazonaws.com/memefi_T_Gapps_screen2_1_b5a4d46f79.png',
      'https://strapi-images-data.s3.eu-central-1.amazonaws.com/memefi_T_Gapps_screen3_1_73fb58aed9.png',
    ],
  },
  {
    id: 'tDVW-318f6c0edd089bab291b51559f6bcedec8a6963afc0a69637bbbd04e22aa3f41-2032915eb993a87d96e3c92eaf3d5a5991aaf3c43167eea1d9e6358f636ff460-fa8877e8201e3e8c1bc35f01a393891f4dde00b6a6a495dbc047edaeabe5d6e8',
    chainId: 'tDVW',
    daoId: '318f6c0edd089bab291b51559f6bcedec8a6963afc0a69637bbbd04e22aa3f41',
    proposalId: '2032915eb993a87d96e3c92eaf3d5a5991aaf3c43167eea1d9e6358f636ff460',
    proposalTitle: '09-10 apps',
    proposalDescription:
      '##GameRanking:skeddy,xrocket,favorite-stickers-bot,tapswap,memefi-coin,breath-of-calm,catizen,blum,okx-racer,dotcoin,water-reminder',
    activeStartTime: '2024-09-10T07:50:08.6967865Z',
    activeEndTime: '2024-09-11T07:50:08.6967865Z',
    appId: 'fa8877e8201e3e8c1bc35f01a393891f4dde00b6a6a495dbc047edaeabe5d6e8',
    alias: 'water-reminder',
    title: 'Water Reminder',
    icon: 'https://strapi-images-data.s3.eu-central-1.amazonaws.com/2024_01_10_17_00_26_867a362693.jpg',
    description: 'This bot will help you drink enough water for a healthy lifestyle.',
    editorChoice: false,
    deployTime: '2024-09-10T07:50:08.6967865Z',
    voteAmount: 0,
    votePercent: 0,
    pointsAmount: 0,
    pointsPercent: 0,
    url: null,
    longDescription: null,
    screenshots: [],
  },
  {
    id: 'tDVW-318f6c0edd089bab291b51559f6bcedec8a6963afc0a69637bbbd04e22aa3f41-2032915eb993a87d96e3c92eaf3d5a5991aaf3c43167eea1d9e6358f636ff460-f9568468951b9369ec2c852260639564e821e7339265bf00b012f1fd4bbc59d1',
    chainId: 'tDVW',
    daoId: '318f6c0edd089bab291b51559f6bcedec8a6963afc0a69637bbbd04e22aa3f41',
    proposalId: '2032915eb993a87d96e3c92eaf3d5a5991aaf3c43167eea1d9e6358f636ff460',
    proposalTitle: '09-10 apps',
    proposalDescription:
      '##GameRanking:skeddy,xrocket,favorite-stickers-bot,tapswap,memefi-coin,breath-of-calm,catizen,blum,okx-racer,dotcoin,water-reminder',
    activeStartTime: '2024-09-10T07:50:08.6967865Z',
    activeEndTime: '2024-09-11T07:50:08.6967865Z',
    appId: 'f9568468951b9369ec2c852260639564e821e7339265bf00b012f1fd4bbc59d1',
    alias: 'dotcoin',
    title: 'Dotcoin',
    icon: 'https://strapi-images-data.s3.eu-central-1.amazonaws.com/2024_04_24_12_15_05_a5e92b5136.jpg',
    description: 'Everything starts from a DOT.',
    editorChoice: false,
    deployTime: '2024-09-10T07:50:08.6967865Z',
    voteAmount: 0,
    votePercent: 0,
    pointsAmount: 0,
    pointsPercent: 0,
    url: 'https://t.me/dotcoin_bot',
    longDescription:
      'Dotcoin is Telegram game where you get Dotcoins by clicking on a DOT. Players can join clans (Telegram channels and chats), complete tasks, invite friends and increase levels.',
    screenshots: [
      'https://strapi-images-data.s3.eu-central-1.amazonaws.com/dotcoin1_72c9d3635d.PNG',
      'https://strapi-images-data.s3.eu-central-1.amazonaws.com/dotcoin2_a71926b62b.PNG',
    ],
  },
  {
    id: 'tDVW-318f6c0edd089bab291b51559f6bcedec8a6963afc0a69637bbbd04e22aa3f41-2032915eb993a87d96e3c92eaf3d5a5991aaf3c43167eea1d9e6358f636ff460-084420cf365d5767c67026ea52f4689c75edec254697e887c46cfef26bccef01',
    chainId: 'tDVW',
    daoId: '318f6c0edd089bab291b51559f6bcedec8a6963afc0a69637bbbd04e22aa3f41',
    proposalId: '2032915eb993a87d96e3c92eaf3d5a5991aaf3c43167eea1d9e6358f636ff460',
    proposalTitle: '09-10 apps',
    proposalDescription:
      '##GameRanking:skeddy,xrocket,favorite-stickers-bot,tapswap,memefi-coin,breath-of-calm,catizen,blum,okx-racer,dotcoin,water-reminder',
    activeStartTime: '2024-09-10T07:50:08.6967865Z',
    activeEndTime: '2024-09-11T07:50:08.6967865Z',
    appId: '084420cf365d5767c67026ea52f4689c75edec254697e887c46cfef26bccef01',
    alias: 'favorite-stickers-bot',
    title: 'Favorite Stickers Bot',
    icon: 'https://strapi-images-data.s3.eu-central-1.amazonaws.com/2023_08_08_11_47_10_66d814ddbc.jpg',
    description:
      'I&#x27;m the emoji and sticker wizard! Transform photos, videos, and GIFs into cool stickers in a snap.',
    editorChoice: false,
    deployTime: '2024-09-10T07:50:08.6967865Z',
    voteAmount: 0,
    votePercent: 0,
    pointsAmount: 0,
    pointsPercent: 0,
    url: 'https://t.me/fStikBot/',
    longDescription: null,
    screenshots: [],
  },
  {
    id: 'tDVW-318f6c0edd089bab291b51559f6bcedec8a6963afc0a69637bbbd04e22aa3f41-2032915eb993a87d96e3c92eaf3d5a5991aaf3c43167eea1d9e6358f636ff460-dae0dc6ce26c6228189f45d9769ccc2e1cb155ef01bbcdaedbf45a12b87cdda8',
    chainId: 'tDVW',
    daoId: '318f6c0edd089bab291b51559f6bcedec8a6963afc0a69637bbbd04e22aa3f41',
    proposalId: '2032915eb993a87d96e3c92eaf3d5a5991aaf3c43167eea1d9e6358f636ff460',
    proposalTitle: '09-10 apps',
    proposalDescription:
      '##GameRanking:skeddy,xrocket,favorite-stickers-bot,tapswap,memefi-coin,breath-of-calm,catizen,blum,okx-racer,dotcoin,water-reminder',
    activeStartTime: '2024-09-10T07:50:08.6967865Z',
    activeEndTime: '2024-09-11T07:50:08.6967865Z',
    appId: 'dae0dc6ce26c6228189f45d9769ccc2e1cb155ef01bbcdaedbf45a12b87cdda8',
    alias: 'breath-of-calm',
    title: 'Breath of Calm',
    icon: 'https://strapi-images-data.s3.eu-central-1.amazonaws.com/2023_12_06_14_15_11_ac341f1ed7.jpg',
    description:
      'Rhythmic breathing to relieve stress and anxiety. Increase concentration. Fall asleep in 20 minutes.',
    editorChoice: false,
    deployTime: '2024-09-10T07:50:08.6967865Z',
    voteAmount: 0,
    votePercent: 0,
    pointsAmount: 0,
    pointsPercent: 0,
    url: 'https://t.me/bcalm_bot',
    longDescription: null,
    screenshots: [],
  },
  {
    id: 'tDVW-318f6c0edd089bab291b51559f6bcedec8a6963afc0a69637bbbd04e22aa3f41-2032915eb993a87d96e3c92eaf3d5a5991aaf3c43167eea1d9e6358f636ff460-1fb1b2cb0b2c9d715ec8ee84b7f3e7683a6278dd5d2b9a36d73be9a2638196f4',
    chainId: 'tDVW',
    daoId: '318f6c0edd089bab291b51559f6bcedec8a6963afc0a69637bbbd04e22aa3f41',
    proposalId: '2032915eb993a87d96e3c92eaf3d5a5991aaf3c43167eea1d9e6358f636ff460',
    proposalTitle: '09-10 apps',
    proposalDescription:
      '##GameRanking:skeddy,xrocket,favorite-stickers-bot,tapswap,memefi-coin,breath-of-calm,catizen,blum,okx-racer,dotcoin,water-reminder',
    activeStartTime: '2024-09-10T07:50:08.6967865Z',
    activeEndTime: '2024-09-11T07:50:08.6967865Z',
    appId: '1fb1b2cb0b2c9d715ec8ee84b7f3e7683a6278dd5d2b9a36d73be9a2638196f4',
    alias: 'catizen',
    title: 'Catizen',
    icon: 'https://strapi-images-data.s3.eu-central-1.amazonaws.com/2024_03_08_15_30_10_12c7b97013.jpg',
    description: 'Play, Earn - Where Every Game Leads to an Airdrop.',
    editorChoice: true,
    deployTime: '2024-09-10T07:50:08.6967865Z',
    voteAmount: 0,
    votePercent: 0,
    pointsAmount: 0,
    pointsPercent: 0,
    url: 'https://t.me/catizenbot',
    longDescription: null,
    screenshots: [],
  },
  {
    id: 'tDVW-318f6c0edd089bab291b51559f6bcedec8a6963afc0a69637bbbd04e22aa3f41-2032915eb993a87d96e3c92eaf3d5a5991aaf3c43167eea1d9e6358f636ff460-eb6d5f7e3dfa89aa451d784b354c4f4e04ab022ba220db0a748a235015ed0047',
    chainId: 'tDVW',
    daoId: '318f6c0edd089bab291b51559f6bcedec8a6963afc0a69637bbbd04e22aa3f41',
    proposalId: '2032915eb993a87d96e3c92eaf3d5a5991aaf3c43167eea1d9e6358f636ff460',
    proposalTitle: '09-10 apps',
    proposalDescription:
      '##GameRanking:skeddy,xrocket,favorite-stickers-bot,tapswap,memefi-coin,breath-of-calm,catizen,blum,okx-racer,dotcoin,water-reminder',
    activeStartTime: '2024-09-10T07:50:08.6967865Z',
    activeEndTime: '2024-09-11T07:50:08.6967865Z',
    appId: 'eb6d5f7e3dfa89aa451d784b354c4f4e04ab022ba220db0a748a235015ed0047',
    alias: 'blum',
    title: 'Blum',
    icon: 'https://strapi-images-data.s3.eu-central-1.amazonaws.com/photo_2024_05_27_19_34_35_84eeee2b39.jpeg',
    description:
      'Blum brings you every coin you need. Just one place, no more switching between multiple platforms.',
    editorChoice: true,
    deployTime: '2024-09-10T07:50:08.6967865Z',
    voteAmount: 0,
    votePercent: 0,
    pointsAmount: 0,
    pointsPercent: 0,
    url: 'https://t.me/BlumCryptoBot',
    longDescription:
      "Your go-to app for crypto trading - all the cool coins and tokens, right in your pocket! Start farming points now, and who knows what cool stuff you'll snag with them soon! Got friends? Bring'em in! The more, the merrier! \n\nRemember: Blum is where growth thrives and endless opportunities bloom!",
    screenshots: [
      'https://strapi-images-data.s3.eu-central-1.amazonaws.com/IMG_6_C88_FD_3_E5055_1_3cad49f054.jpeg',
      'https://strapi-images-data.s3.eu-central-1.amazonaws.com/IMG_CB_1217_F717_BC_1_23de4fcb38.jpeg',
      'https://strapi-images-data.s3.eu-central-1.amazonaws.com/IMG_611339_AB_55_F1_1_4ac00f98bf.jpeg',
    ],
  },
  {
    id: 'tDVW-318f6c0edd089bab291b51559f6bcedec8a6963afc0a69637bbbd04e22aa3f41-2032915eb993a87d96e3c92eaf3d5a5991aaf3c43167eea1d9e6358f636ff460-3188e85c8e633a2de635d968b3f27b418c94e745b7c78af2c906da06ee229e8a',
    chainId: 'tDVW',
    daoId: '318f6c0edd089bab291b51559f6bcedec8a6963afc0a69637bbbd04e22aa3f41',
    proposalId: '2032915eb993a87d96e3c92eaf3d5a5991aaf3c43167eea1d9e6358f636ff460',
    proposalTitle: '09-10 apps',
    proposalDescription:
      '##GameRanking:skeddy,xrocket,favorite-stickers-bot,tapswap,memefi-coin,breath-of-calm,catizen,blum,okx-racer,dotcoin,water-reminder',
    activeStartTime: '2024-09-10T07:50:08.6967865Z',
    activeEndTime: '2024-09-11T07:50:08.6967865Z',
    appId: '3188e85c8e633a2de635d968b3f27b418c94e745b7c78af2c906da06ee229e8a',
    alias: 'tapswap',
    title: 'TapSwap',
    icon: 'https://strapi-images-data.s3.eu-central-1.amazonaws.com/2024_05_29_00_22_59_7a7dd228c2.jpg',
    description: 'Tap on the coin and see your balance rise.',
    editorChoice: true,
    deployTime: '2024-09-10T07:50:08.6967865Z',
    voteAmount: 0,
    votePercent: 0,
    pointsAmount: 0,
    pointsPercent: 0,
    url: 'https://t.me/tapswap_bot',
    longDescription:
      "TapSwap is a cutting-edge financial platform where users can earn tokens by leveraging the mining app's various features. The majority of TapSwap Token (TAPS) distribution will occur among the players here. Do you have friends, relatives, or co-workers? Bring them all into the game. More buddies, more coins.",
    screenshots: [
      'https://strapi-images-data.s3.eu-central-1.amazonaws.com/tapswap1_27a58e7fad.PNG',
      'https://strapi-images-data.s3.eu-central-1.amazonaws.com/tapswap2_3ac44b5b75.PNG',
      'https://strapi-images-data.s3.eu-central-1.amazonaws.com/tapswap3_e538bfd38d.PNG',
      'https://strapi-images-data.s3.eu-central-1.amazonaws.com/tapswap4_163811b512.PNG',
    ],
  },
  {
    id: 'tDVW-318f6c0edd089bab291b51559f6bcedec8a6963afc0a69637bbbd04e22aa3f41-2032915eb993a87d96e3c92eaf3d5a5991aaf3c43167eea1d9e6358f636ff460-b2da030c47833de59f4ed6456b205c34ac97ad0c19b6956bf9488f60317dc543',
    chainId: 'tDVW',
    daoId: '318f6c0edd089bab291b51559f6bcedec8a6963afc0a69637bbbd04e22aa3f41',
    proposalId: '2032915eb993a87d96e3c92eaf3d5a5991aaf3c43167eea1d9e6358f636ff460',
    proposalTitle: '09-10 apps',
    proposalDescription:
      '##GameRanking:skeddy,xrocket,favorite-stickers-bot,tapswap,memefi-coin,breath-of-calm,catizen,blum,okx-racer,dotcoin,water-reminder',
    activeStartTime: '2024-09-10T07:50:08.6967865Z',
    activeEndTime: '2024-09-11T07:50:08.6967865Z',
    appId: 'b2da030c47833de59f4ed6456b205c34ac97ad0c19b6956bf9488f60317dc543',
    alias: 'xrocket',
    title: 'xRocket',
    icon: 'https://strapi-images-data.s3.eu-central-1.amazonaws.com/2023_10_26_15_30_35_4a7bc164fc.jpg',
    description: 'Trade, send, and receive popular cryptocurrencies.',
    editorChoice: false,
    deployTime: '2024-09-10T07:50:08.6967865Z',
    voteAmount: 0,
    votePercent: 0,
    pointsAmount: 0,
    pointsPercent: 0,
    url: 'https://t.me/xrocket',
    longDescription: null,
    screenshots: [
      'https://strapi-images-data.s3.eu-central-1.amazonaws.com/Slide_2_6efea57346.png',
      'https://strapi-images-data.s3.eu-central-1.amazonaws.com/Slide_1_b4504f7e8e.png',
      'https://strapi-images-data.s3.eu-central-1.amazonaws.com/Slide_3_737a9e1166.png',
      'https://strapi-images-data.s3.eu-central-1.amazonaws.com/Slide_4_978ee1871a.png',
    ],
  },
  {
    id: 'tDVW-318f6c0edd089bab291b51559f6bcedec8a6963afc0a69637bbbd04e22aa3f41-2032915eb993a87d96e3c92eaf3d5a5991aaf3c43167eea1d9e6358f636ff460-abaaf5f673d86b9d824030a466f0df3e83584c7dadce9d616400023fa9778043',
    chainId: 'tDVW',
    daoId: '318f6c0edd089bab291b51559f6bcedec8a6963afc0a69637bbbd04e22aa3f41',
    proposalId: '2032915eb993a87d96e3c92eaf3d5a5991aaf3c43167eea1d9e6358f636ff460',
    proposalTitle: '09-10 apps',
    proposalDescription:
      '##GameRanking:skeddy,xrocket,favorite-stickers-bot,tapswap,memefi-coin,breath-of-calm,catizen,blum,okx-racer,dotcoin,water-reminder',
    activeStartTime: '2024-09-10T07:50:08.6967865Z',
    activeEndTime: '2024-09-11T07:50:08.6967865Z',
    appId: 'abaaf5f673d86b9d824030a466f0df3e83584c7dadce9d616400023fa9778043',
    alias: 'okx-racer',
    title: 'OKX Racer',
    icon: 'https://strapi-images-data.s3.eu-central-1.amazonaws.com/2024_07_22_23_39_35_015277c3d8.jpg',
    description: 'Rev your engines and guess token prices in real-time! ',
    editorChoice: false,
    deployTime: '2024-09-10T07:50:08.6967865Z',
    voteAmount: 0,
    votePercent: 0,
    pointsAmount: 0,
    pointsPercent: 0,
    url: 'https://t.me/OKX_official_bot',
    longDescription:
      'Welcome to the OKX Racer! Rev your engines and predict token prices in real-time! Moon or doom in the next 5 seconds? Correct guesses earn points and surprises! Boost your score by inviting friends! Do you have what it takes to be at the top?',
    screenshots: [
      'https://strapi-images-data.s3.eu-central-1.amazonaws.com/okx1_554d82ea06.PNG',
      'https://strapi-images-data.s3.eu-central-1.amazonaws.com/okx2_c19e4657ab.PNG',
      'https://strapi-images-data.s3.eu-central-1.amazonaws.com/okx3_fb4061e709.PNG',
    ],
  },
];
